export const SELECTION_TEXT_MIX_4 = [
  'Vi ved godt, det er svært at vælge…',
  'Nu mangler du kun at vælge 3!',
  '2 streamingtjenester tilbage…',
  'Du er der næsten!',
  'Ja tak! 4 gode valg.'
]
export const SELECTION_TEXT_MIX_3 = [
  'Vi ved godt, det er svært at vælge…',
  'Nu mangler du kun at vælge 2!',
  'Du er der næsten!',
  'Ja tak! 3 gode valg.'
]
